[...document.querySelectorAll('.scroll-to')].forEach(function(element) { //makes use of ... spread operator to convert to array
  element.addEventListener('click', ( e ) => {
    e.preventDefault();
    let trgt = element.getAttribute('href');
    let trgtId = trgt.replace('#', '');
    let trgtEl = document.getElementById( trgtId );
    scrollTo( trgtEl, 0 );
  });
});


export function scrollTo( trgt, offsetTop = 40 ){
  let elementCoords = trgt.getBoundingClientRect();
  let elTop = elementCoords.top;

  window.scroll({
    top: window.scrollY + elTop - offsetTop,
    left: 0,
    behavior: 'smooth'
  })

}
